import React from 'react';
import no_search_svg from 'src/images/empty.png';
import no_goods_svg from 'src/svgs/no-goods.svg';
import no_order_svg from 'src/svgs/system-jumping.svg';
import no_search_counpongoods from 'src/svgs/no-search-counpongoods.svg';
import nopromotioncoupon from 'src/images/nodata.png';
import EmptyCover from './emptyCover';

const emptyConfig = {
  goods: {
    text: '暂无记录',
    icon: no_goods_svg,
  },
  order: {
    text: '暂时没有购物记录',
    icon: no_order_svg,
  },
  search: {
    text: '无搜索结果',
    icon: no_search_svg,
  },
  couponsearch: {
    text: '暂无可用商品',
    icon: no_search_counpongoods,
  },
  conversion: {
    text: '',
    icon: no_goods_svg,
  },
  depositRecord: {
    text: '暂无消费明细',
    icon: no_goods_svg,
  },
  couponReferral: {
    text: '找不到这张优惠券了',
    icon: nopromotioncoupon,
  },
};

export default {
  goodsEmpty: () => <EmptyCover config={emptyConfig.goods} type="goods" />,
  orderTextEmpty: () => <EmptyCover config={emptyConfig.order} type="text" />,
  searchEmpty: () => <EmptyCover config={emptyConfig.search} type="search" />,
  couponsearchEmpty: () => <EmptyCover config={emptyConfig.couponsearch} type="couponsearch" />,
  conversionEmpty: () => <EmptyCover config={emptyConfig.conversion} type="conversion" />,
  couponReferralEmpty: () => <EmptyCover config={emptyConfig.couponReferral} type="couponReferral" />,
  depositRecordEmpty: () => <EmptyCover config={emptyConfig.depositRecord} type="depositRecord" />,
};
